import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=a4449a2c&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=a4449a2c&prod&scoped=true&lang=css"
import style1 from "./cooperation.vue?vue&type=style&index=1&id=a4449a2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4449a2c",
  null
  
)

export default component.exports